import React, { useContext } from 'react';
import { AppContext, DataList, APPLICATION_JSON } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import useService from '../../../useService';
import { columnConfigs, DEFAULT_CONFIG } from './listConfig';

const UserRtfsList: React.FC<{}> = () => {
	const { requestGetRtfs } = useService();
	const { showAlert } = useContext(AppContext);
	const [css] = useStyletron();
	const topBarStyle: string = css({ margin: '10px', display: 'flex', justifyContent: 'center' });
	const downloadJsonData = async (): Promise<void> => {
		try {
			const response: { jsonData: object; zupeeUserId: string } = await requestGetRtfs();
			const jsonData: string = JSON.stringify(response.jsonData, null, 2);
			const blob: Blob = new Blob([jsonData], { type: APPLICATION_JSON });
			const url: string = URL.createObjectURL(blob);
			const anchorElement: HTMLAnchorElement = document.createElement('a');
			anchorElement.href = url;
			anchorElement.download = `${response.zupeeUserId}.json`;
			anchorElement.click();
			URL.revokeObjectURL(url);
			showAlert('Data Downloaded Successfully');
		} catch (error) {
			showAlert('Error while downloading data', { type: 'error' });
		}
	};
	return (
		<>
			<div>
				<div className={topBarStyle}>
					<span className={topBarStyle}>
						<Button type='button' onClick={downloadJsonData}>
							Download JSON Data
						</Button>
					</span>
				</div>
			</div>
			<DataList
				fetchData={requestGetRtfs}
				columnConfigs={columnConfigs}
				defaults={DEFAULT_CONFIG}
				disablePagination={false}
				disablePaginationSelect={false}
				entity={LIST_ENTITY_NAMES.USER_SEGMENT}
				disableColumnFilter
				rowHeight={100}
				filterable={false}
				searchable={false}
			/>
		</>
	);
};

export default UserRtfsList;
